/**
 * Paths that only exist for a signed-in user.
 *
 * Deliberately just strings, with no component imports: NavigationComponent needs
 * this list on every page load to decide whether to show a loading state while the
 * session lookup is in flight, and importing the dashboard components here would
 * pull the whole signed-in bundle back into the critical path that AppShell exists
 * to split out.
 *
 * PrivateRoutes maps each of these to a component through a
 * `Record<PrivatePath, ...>`, so adding a path here without wiring up a route (or
 * the reverse) is a type error rather than a blank page.
 */
export const PRIVATE_PATHS = [
    '/dashboard',
    '/families',
    '/translatables',
    '/translations',
    '/translation-jobs',
    '/billing',
    '/admin/users',
    '/api-keys',
] as const;

export type PrivatePath = typeof PRIVATE_PATHS[number];

/** True if `pathname` addresses a signed-in-only route. */
export function isPrivatePath(pathname: string): boolean {
    // Trailing slashes are equivalent for routing purposes but not for string
    // comparison, and CloudFront happily serves both.
    const normalised = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    return (PRIVATE_PATHS as readonly string[]).includes(normalised);
}
